import { mapGetters, mapState } from 'vuex'
import listItemTeam from '@/components/list-item-team/list-item-team.vue'
import listItemPlayer from '@/components/list-item-player/list-item-player.vue'
import groupTable from '@/components/group-table/group-table.vue'
import listItemMatch from '@/components/list-item-match/list-item-match.vue'
import timelineItemMatch from '@/components/timeline-item-match/timeline-item-match.vue'

export default {
  components: {
    listItemTeam,
    listItemPlayer,
    groupTable,
    listItemMatch,
    timelineItemMatch
  },
  data () {
    return {
      group: '',
      tab: 0,
      editMode: false
    }
  },
  computed: {
    ...mapState(['groups', 'teams', 'user', 'matches', 'players', 'superBadges']),
    ...mapGetters(['fullTimeline']),
    timeline () {
      let dateFiltered = this.fullTimeline
        .filter(item => {
          const endTime =
            +1696543200000 + // Friday midnight
            86400000 * (item.day || 0) + // Day of event
            3600000 * parseInt(item.timeStart.substring(0, 2), 10) + // Start hour
            60000 * parseInt(item.timeStart.substring(3, 5), 10) + // Start minute
            60000 * parseInt(item.durationSeconds || item.duration || 0) // Duration
          return +new Date() <= +new Date(endTime)
        })
      if (dateFiltered.length < 2) {
        dateFiltered = this.fullTimeline
      }
      return dateFiltered
        .filter(t => {
          return this.group !== 'yours' || t.type === 'timeline' || this.user.assignedTeam === t.team1 || this.user.assignedTeam === t.team2
        })
        .reduce((prev, next) => {
          const lastItem = prev.length ? prev[prev.length - 1].items[prev[prev.length - 1].items.length - 1] : null
          if (!lastItem || lastItem.timeStart !== next.timeStart) {
            prev.push({
              timeStart: next.timeStart,
              type: next.type,
              items: [next]
            })
          } else {
            prev[prev.length - 1].items.push(next)
          }
          return prev
        }, [])
    },
    timelineGrouped () {
      const groups = [{
        id: 'friday',
        title: 'Piątek, 6 października',
        timeline: this.timeline.filter(t => t.items[0].day === 0)
      }, {
        id: 'saturday',
        title: 'Sobota, 7 października',
        timeline: this.timeline.filter(t => t.items[0].day === 1)
      }, {
        id: 'sunday',
        title: 'Niedziela, 8 października',
        timeline: this.timeline.filter(t => t.items[0].day === 2)
      }]
      if (['friday', 'saturday', 'sunday'].includes(this.group)) {
        return groups.filter(g => g.id === this.group)
      }
      return groups.filter(g => g.timeline.length)
    },
    rankMatches () {
      return this.matches.filter(m => m.isRankGame)
    },
    rankTeams () {
      return Object.values(this.teams).filter(t => t.finalRank)
        .sort((a, b) => {
          return a.finalRank - b.finalRank
        })
    },
    rankPlayers () {
      const rankBadges = this.superBadges.filter(b => b.finalRank === true).map(b => b.id)
      return Object.values(this.players).filter(p => {
        return !!(p.badges || []).find(b => rankBadges.includes(b))
      })
        .map(p => {
          p.finalBadge = (p.badges || []).find(b => rankBadges.includes(b))
          return p
        })
    }
  }
}
